import { CSSObject } from '@emotion/react'
import { Color } from '@opallabs/gem'
import { fontSizes, fontWeights } from '@opallabs/pulsar'

export const containerStyles: CSSObject = {
  blockSize: '92px',
  paddingBlock: '16px',
  paddingInline: '8px',
  boxSizing: 'border-box',
  fontSize: fontSizes.xSmall,
  fontWeight: fontWeights.bold,
  background: Color.light.Surface.N200,
}

export const buttonStyles: CSSObject = {
  textTransform: 'inherit',
  fontSize: fontSizes.medium,
  fontWeight: fontWeights.medium,
  blockSize: '24px',
  background: Color.light.Surface.N000,
  color: Color.light.Text.Default,
  border: '1px solid #e1e4e6',
  borderRadius: '4px',
}
